module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.is_ready) ? _c('div', {
    staticClass: "main-container",
    class: _vm.mainClasses
  }, [_c('notification'), _vm._v(" "), _c('modals'), _vm._v(" "), (_vm.layout == 'classic') ? _c('layout', {
    on: {
      "logout": _vm.logout
    }
  }) : (_vm.layout == 'fluid') ? _c('fluid-layout', {
    on: {
      "logout": _vm.logout
    }
  }) : (_vm.layout == 'public') ? _c('public-layout', {
    on: {
      "login": _vm.login
    }
  }) : (_vm.layout == 'dashboard') ? _c('dashboard-layout', {
    on: {
      "login": _vm.login
    }
  }) : (_vm.layout == 'empty') ? _c('empty-layout') : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4507c1cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1886
// module chunks = 0